export default __webpack_public_path__ + "static/media/FuncionandoAlarme.04641e08.svg";